const getToolPanelSlot = function (canvas: Element, toolNames: string[]): Array<Element | null | undefined> {
  return toolNames.map((toolName) => {
    return canvas.shadowRoot?.querySelector(`slot[name="tool-panel-${toolName}"]`);
  });
};

export default function applyStyleShadowDom(
  gmfDesktopCanvasStyles: string,
  toolButtonStyle: string,
  gmfAuthFormStyle: string,
  gmfAuthPanelStyle: string,
) {
  document.addEventListener('DOMContentLoaded', () => {
    // Function to apply styles to shadow DOM elements
    function styleShadowDom(element: HTMLElement, styles: string) {
      if (element && element.shadowRoot) {
        const shadowRoot = element.shadowRoot;
        if ('adoptedStyleSheets' in shadowRoot) {
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(styles);
          shadowRoot.adoptedStyleSheets.push(sheet);
        } else {
          const styleElement = document.createElement('style');
          styleElement.textContent = styles;
          shadowRoot.appendChild(styleElement);
        }
      }
    }

    // Apply styles to gmf-desktop-canvas
    const gmfDesktopCanvas = document.querySelector('gmf-desktop-canvas');
    if (gmfDesktopCanvas && gmfDesktopCanvas.shadowRoot) {
      styleShadowDom(gmfDesktopCanvas as HTMLElement, gmfDesktopCanvasStyles);
      const closeButton = gmfDesktopCanvas.shadowRoot.querySelector(
        '#gmf-app-tools-content .close',
      ) as HTMLElement;
      const updateCloseButtonVisibility = () => {
        if (!gmfDesktopCanvas.shadowRoot) {
          return;
        }
        const slots = getToolPanelSlot(gmfDesktopCanvas, ['auth', 'gr-geofunctions', 'gr-gever']);
        if (slots.some((value) => value !== null)) {
          closeButton.style.display = 'block'; // Show the close button if any slot has assigned nodes
        } else {
          closeButton.style.display = 'none'; // Hide the close button if no slots have assigned nodes
        }
      };
      // Initial check
      updateCloseButtonVisibility();
      // Observe changes in the shadow DOM
      const observer = new MutationObserver(updateCloseButtonVisibility);
      observer.observe(gmfDesktopCanvas.shadowRoot, {childList: true, subtree: true});
    }

    const gmfAuthPanel = document.querySelector('gmf-auth-panel');
    if (gmfAuthPanel && gmfAuthPanel.shadowRoot) {
      styleShadowDom(gmfAuthPanel as HTMLElement, gmfAuthPanelStyle);
      // Traverse to gmf-auth-form within gmf-auth-panel
      const gmfAuthForm = gmfAuthPanel.shadowRoot.querySelector('gmf-auth-form');
      if (gmfAuthForm) {
        styleShadowDom(gmfAuthForm as HTMLElement, gmfAuthFormStyle);
      }
    }

    // Apply styles to tool buttons
    const toolButtons = document.querySelectorAll(
      'gmf-auth-button, \
      gmf-print-button, \
      gmf-filter-button, \
      gmf-draw-button, \
      gmf-editing-button, \
      gmf-profile-button, \
      gmf-googlestreetview-button, \
      gmf-selection-button, \
      gmf-import-button, \
      gr-oeedit-button, \
      gr-geofunctions-button, \
      gr-gever-button, \
      geo-shop-open-button',
    );
    toolButtons.forEach((element) => {
      if (element.shadowRoot) {
        styleShadowDom(element as HTMLElement, toolButtonStyle);
      }
    });
  });
}
